import { FunctionComponent, ReactElement } from 'react';

const AppContent: FunctionComponent<React.PropsWithChildren> = ({ children }) =>
  children as ReactElement;

export default AppContent;
